import { onBeforeUnmount, onMounted, ref, toValue } from 'vue';

export default function useSidebarResize({
  sidebar_width,
  width_min = 300,
  width_max = 800,
  direction = 'left',
  onResize,
}) {
  const is_resizing = ref(false);
  const x_start = ref(0);
  const width_start = ref(0);

  const start_resize = (event) => {
    is_resizing.value = true;
    x_start.value = event.clientX;
    width_start.value = sidebar_width.value;
    document.body.classList.add('cursor-col-resize');
    event.preventDefault();
  };

  const stop_resize = () => {
    if (is_resizing.value) {
      is_resizing.value = false;
      document.body.classList.remove('cursor-col-resize');
      onResize(sidebar_width.value);
    }
  };

  const handle_resize = (event) => {
    if (!is_resizing.value) return;
    if (event.buttons === 0) {
      stop_resize();
      return;
    }
    const deltaX = event.clientX - x_start.value;
    const new_width = direction === 'left' ? width_start.value - deltaX : width_start.value + deltaX;
    onResize(Math.max(toValue(width_min), Math.min(toValue(width_max), new_width)));
  };

  onMounted(() => {
    document.addEventListener('pointermove', handle_resize);
    document.addEventListener('pointerup', stop_resize);
    document.addEventListener('pointercancel', stop_resize);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('pointermove', handle_resize);
    document.removeEventListener('pointerup', stop_resize);
    document.removeEventListener('pointercancel', stop_resize);
    if (is_resizing.value) document.body.classList.remove('cursor-col-resize');
  });

  return { is_resizing, start_resize };
}
